import * as React from 'react';
import { TextField, PrimaryButton } from '@fluentui/react';
import axios from 'axios';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import { DefaultButton } from '@fluentui/react';

export class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            message: '',
            errorMessage: '',
            showSuccess: false,
            showError:false
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleMessageChange = this.handleMessageChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        var model = {
            Name: this.state.name,
            Email: this.state.email,
            Message: this.state.message,
            Type: this.props.type
        }

        axios.post(AUTH_CONFIG.API_URL + "/api/Helper/Contact", model)
            .then((response) => {
                this.setState({
                    showSuccess: true,
                    name: '',
                    email: '',
                    message: '',
                    showSuccess:true
                });
            });
    }
    handleNameChange(event) {
        this.setState({
            name: event.target.value
        });
    }
    handleEmailChange(event) {
        this.setState({
            email: event.target.value
        });
    }
    handleMessageChange(event) {
        
        this.setState({
            message: event.target.value
        });
    }

render() {
    return (
        <form id="ContactForm" name="ContactForm" className="default-form" style={{ maxWidth: 400 }} noValidate="noValidate" autoComplete="off" onSubmit={this.handleSubmit}>
            {this.state.showError &&
                <div className="alert alert-danger" style={{ 'margin': "5px 0px 0px"}}>
                    <strong>Error:</strong> {this.state.errorMessage}
                </div>
            }
            {this.state.showSuccess && this.props.type == 'support' &&
                <div className="alert alert-info" style={{ 'margin': "5px 0px 0px" }}>
                    <strong>Success!</strong> Someone will get back to your shortly.
                </div>
            }
            {this.state.showSuccess && this.props.type == 'request' &&
                <div className="alert alert-info" style={{ 'margin': "5px 0px 0px" }}>
                    <strong>Awesome!</strong> Thanks for your request.
                </div>
            }
            <div className="form-group pb10 ">
                <label for="Name" className="control-label">Name</label>
                <TextField type="text" className="form-control" name="Name"
                    value={this.state.name}
                    onChange={this.handleNameChange} />
            </div>
            <div className="form-group pb10 ">
                    <label for="Email" className="control-label">Email</label>
                <TextField type="text" className="form-control"  name="Email"
                        value={this.state.email}
                        onChange={this.handleEmailChange} />
                </div>
            <div className="form-group ">
                {this.props.type == 'support' && 
                    <label for="Message" className="control-label">Message</label>
                }
                {this.props.type == 'request' &&
                    <label for="Message" className="control-label">Request</label>
                }
                <TextField className="form-control" id="Message" name="Message" multiline rows={3} 
                        value={this.state.message}
                        onChange={this.handleMessageChange}/>
                </div>

                <div className="m-t-30">
                <DefaultButton
                    text="Submit"
                    primary
                    onClick={this.handleSubmit}
                />
                </div>
            </form>
    );
}
}
